import type { IActionsFields } from '@mentimeter/content-contentful/legacy/types/generated/contentful';
import { linkActionFields } from 'src/utils/linkActionFields';
import type { ActionT } from 'src/ui/actions/Action';
import { getDynamicValueDependingOnUser } from './getDynamicValueDependingOnUser';

export function getDynamicContentfulReferenceActions({
  hasUser,
  value,
}: {
  hasUser: boolean;
  value: IActionsFields | null;
}): Array<ActionT> | undefined {
  const actions = getDynamicValueDependingOnUser({ hasUser, value });

  if (!actions) return;

  return actions
    .map(({ fields }) => linkActionFields(fields))
    .filter(Boolean) as ActionT[];
}
